"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const LandingActions_1 = require("./LandingActions");
const utils_1 = require("../utils");
const util_1 = require("util");
const constants_1 = require("../constants");
const react_bootstrap_1 = require("react-bootstrap");
const api_1 = require("../api");
function mapDispatchToProps(dispatch) {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal)),
        dispatch
    };
}
function mapStateToProps(state = constants_1.INITIAL_STATE) {
    return {
        PasswordRecoveryProgress: state.landingPage.registerProgress,
        PasswordRecoveryErrors: state.landingPage.registerErrors
    };
}
class PasswordRecoveryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.password = "";
        this.confirmPassword = "";
        this.PasswordRecovery = this.PasswordRecovery.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.Loading,
            shouldUpdate: true
        };
    }
    componentDidMount() {
        console.log('this.props', this.props);
        document.body.scrollTop = 0;
    }
    PasswordRecovery() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.isValid()) {
                    this.setState({ shouldUpdate: true });
                    yield api_1.doPost(api_1.API.v1.UPDATE_PASSWORD, {
                        temporaryToken: this.props.location.query.token.replaceAll('*', '.'),
                        password: this.password
                    });
                    window.location.href = '/en/login';
                }
            } catch (err) {
                this.setState({
                    password: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "Something went wrong."
                    }
                });
            }
        });
    }
    handleKeyPress(target) {
        if (target.charCode == 13) {
            switch (target.target.name) {
                case "password":
                    $(".panel-body #confirmPassword").focus();
                    break;
                case "confirmPassword":
                    this.PasswordRecovery();
                    break;
            }
        }
    }
    componentDidUpdate() {
        if (!util_1.isNullOrUndefined(this.props.PasswordRecoveryErrors)) {
            this.props.PasswordRecoveryErrors.forEach(err => {
                if (err.reason == "WRONG_PASSWORD_LENGTH" && err.param == "password") {
                    this.setState({
                        password: {
                            state: constants_1.ProgressState.Failed,
                            errorMessage: "Wrong password length."
                        }, shouldUpdate: false
                    });
                }
            });
        }
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        const PasswordRecoveryProgress = this.props.PasswordRecoveryProgress || constants_1.ProgressState.None;
        return React.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => {}, className: "landing-modal" }, React.createElement(react_bootstrap_1.Modal.Body, { className: "landing-modal-body" }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel" }, React.createElement("div", { className: "userpic" }, React.createElement("img", { src: "../img/default_profile.png", alt: "" })), React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Type new password"), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "password_signup_cy", controlId: "password" }, utils_1.FormUtils.formGroupAttributes(this.state.password)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Password", name: "password", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.password)), React.createElement("br", null), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "confirm-password_signup_cy", controlId: "confirmPassword" }, utils_1.FormUtils.formGroupAttributes(this.state.confirmPassword)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Confirm Password", name: "confirmPassword", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.confirmPassword)), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { "data-cy": "signUpButton", className: "modal-button", title: "Password Recovery", bsStyle: "primary", onClick: this.PasswordRecovery }, "Submit")))));
    }
    isValid() {
        let valid = true;
        if (validator.isEmpty(this.password)) {
            valid = false;
            this.setState({
                password: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Password is required."
                }
            });
        } else {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.confirmPassword)) {
            valid = false;
            this.setState({
                confirmPassword: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Confirm Password is required."
                }
            });
        } else {
            this.setState({
                confirmPassword: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (this.confirmPassword !== this.password) {
            valid = false;
            this.setState({
                password: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Passwords are not same"
                }
            });
        }
        return valid;
    }
}
const PasswordRecovery = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PasswordRecoveryComponent);
exports.default = PasswordRecovery;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/PasswordRecovery.tsx
// module id = 1340
// module chunks = 0 1